import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.entries";
import "core-js/modules/web.dom.iterable";
import Vue from 'vue';
import itemsToProvide from '@/setup/globalInjection/globalInjection';

var provide = function provide() {
  return {};
};

try {
  provide = function provide() {
    var symbolizedKeys = {};
    Object.entries(itemsToProvide).forEach(function (element) {
      symbolizedKeys[Symbol.for(element[0])] = element[1];
    });
    return symbolizedKeys;
  }; // tslint:disable-next-line:no-empty

} catch (e) {}

export default Vue.extend({
  provide: provide
});